import { CustomizationMappingFields } from "./communication-request.model";

export enum CustomizationDtoProcessStatus {
    Loading = 1,
    Completed,
    Inactive
}

export class ProgramCustomizationDto {
    thumbnailLocation: any;
    programTacticId: number;
    programTacticName: string;
    proofURL: string;
    customizationRequest: CustomizationDto[]
}

export class CustomizationDisplayOptionDto
{
    id: number;
    customizationDisplayOptionName: string;
    parentId: number;
    parentCustomizationRequestId: number;
}

export class CustomizationDto
{
    id: number;
    cdO_ParentID: number;
    customizationRequestName: string;
    customizationRequestUIElementId: number;
    customizationRequestPostion: number;
    customizationDisplayOption: CustomizationDisplayOptionDto[];
    customizationDisplayOptionCount: number;
    customizationRequestTemplateFile: any;

    customizationEntry: string;
    customizationEntryId: number;
    customizationEntryFiles: File[];
    status: CustomizationDtoProcessStatus = CustomizationDtoProcessStatus.Inactive;
    isRequired: boolean;
}

export enum UIElementType {
    DropDown = 1,
    DatePicker,
    TextBox
}

export class UpdateCustomizationDto
{
    ProgramTacticId: number;
    CustomizationRequestId: number;
    CustomizationDisplayOptionId: number;
    CustomizaitonEntry: string;
    MappingFields?: CustomizationMappingFields[];
}


// WEBPACK FOOTER //
// ./src/app/client-core/dtos/customization.model.ts